export default __webpack_public_path__ + "static/media/lock-unlock.d8eb965d.svg";